<template>
  <v-dialog v-if="dialog.show" v-model="dialog.show" width="500">
    <v-card>
      <v-card-title :class="dialog.color" class="white--text">
        <div class="title">
          <v-icon color="white">{{
            dialog.color == "error"
              ? "$vuetify.icons.rms_sad"
              : "$vuetify.icons.rms_happy"
          }}</v-icon>
          <span v-if="dialog.color == 'error'">{{
            $t("screener.error.title")
          }}</span>
          <span v-else>{{ $t("screener.success.title") }}</span>
        </div>
        <v-spacer></v-spacer>
        <v-icon small class="white--text" @click="dialog.show = false"
          >close</v-icon
        >
      </v-card-title>
      <v-card-text
        class="subheading py-4 text-xs-center"
        v-html="dialog.text"
        >{{ dialog.text }}</v-card-text
      >
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" dark flat outline @click="dialog.show = false">{{
          $t("screener.btn.close")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AlertMessage",
  props: {
    dialog: {}
  }
};
</script>

<style>
</style>
